import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import OrderForm from './OrderForm';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

const OrderFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [editingOrder, setEditingOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load order for editing if ID is provided
  React.useEffect(() => {
    if (id) {
      fetchOrderForEdit();
    }
  }, [id]);

  const fetchOrderForEdit = async () => {
    try {
      setLoading(true);
      const orderDoc = await getDoc(doc(db, 'orders', id));
      if (orderDoc.exists()) {
        setEditingOrder({ id: orderDoc.id, ...orderDoc.data() });
      } else {
        console.error('Order not found');
        navigate(buildBackUrl());
      }
    } catch (error) {
      console.error('Error fetching order:', error);
      navigate(buildBackUrl());
    } finally {
      setLoading(false);
    }
  };

  // Build back URL with preserved search state
  const buildBackUrl = () => {
    const from = searchParams.get('from');
    if (from === 'dashboard') {
      return '/';
    } else if (from === 'detail' && id) {
      // If coming from order detail and editing, go back to order detail
      return `/orders/${id}`;
    } else {
      // Build orders list URL with preserved search state
      const backParams = new URLSearchParams();
      const search = searchParams.get('search');
      const type = searchParams.get('type');
      const bookmarked = searchParams.get('bookmarked');
      const hideArchived = searchParams.get('hideArchived');
      const page = searchParams.get('page');
      
      if (search) backParams.set('search', search);
      if (type) backParams.set('type', type);
      if (bookmarked) backParams.set('bookmarked', bookmarked);
      if (hideArchived) backParams.set('hideArchived', hideArchived);
      if (page) backParams.set('page', page);
      
      const queryString = backParams.toString();
      return `/orders${queryString ? `?${queryString}` : ''}`;
    }
  };

  const handleClose = () => {
    navigate(buildBackUrl());
  };

  const handleSuccess = (order) => {
    const from = searchParams.get('from');
    if (from === 'dashboard' && !id) {
      // If creating new order from dashboard, go back to dashboard
      navigate('/');
    } else if (id) {
      // If editing, go to order detail (preserve from parameter for proper navigation)
      navigate(`/orders/${order.id}${from === 'dashboard' ? '?from=dashboard' : ''}`);
    } else {
      // If creating new, go to new order detail
      navigate(`/orders/${order.id}`);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-lg text-gray-600">Cargando orden...</div>
        </div>
      </div>
    );
  }

  return (
    <OrderForm
      isOpen={true}
      onClose={handleClose}
      onSuccess={handleSuccess}
      editingOrder={editingOrder}
    />
  );
};

export default OrderFormPage;